import { useCallback, useEffect, useState } from 'react';

import type { BlackoutDraft, BlackoutFormValues } from './types';

// Local session state for the Blackouts tab - mirrors useInclusionDrafts: in-memory
// `useState`, no persistence, reset when the offer changes. "Save Session" stays
// disabled until svc-offer draft persistence is wired (XTRNT-1073).
export function useBlackouts(offerId: string | undefined) {
  const [blackouts, setBlackouts] = useState<Array<BlackoutDraft>>([]);

  useEffect(() => {
    setBlackouts([]);
  }, [offerId]);

  const addBlackout = useCallback((values: BlackoutFormValues) => {
    const now = new Date().toISOString();
    const draft: BlackoutDraft = { ...values, id: crypto.randomUUID(), createdAt: now, updatedAt: now };
    setBlackouts((prev) => [...prev, draft]);
    return draft;
  }, []);

  const updateBlackout = useCallback((id: string, changes: Partial<BlackoutFormValues>) => {
    setBlackouts((prev) =>
      prev.map((draft) => (draft.id === id ? { ...draft, ...changes, updatedAt: new Date().toISOString() } : draft)),
    );
  }, []);

  const removeBlackout = useCallback((id: string) => {
    setBlackouts((prev) => prev.filter((draft) => draft.id !== id));
  }, []);

  return { blackouts, addBlackout, updateBlackout, removeBlackout, setBlackouts };
}
